// User Messages functionality
export function getUserMessages() {
    fetch('/api/user-messages/', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Error fetching user messages');
        }
        return response.json();
    })
    .then(data => {
        const container = document.getElementById('user-messages-container');
        if (container && data.messages && data.messages.length > 0) {
            container.classList.add('container-fluid', 'my-4');
            container.innerHTML = '';
            data.messages.forEach(message => {
                const messageDiv = document.createElement('div');
                messageDiv.className = `member-alert ${message.level_tag} d-flex align-items-center`;
                messageDiv.innerHTML = `
                    ${message.message}
                `;
                container.appendChild(messageDiv);
            });
        }
    })
    .catch(error => {
        console.error('Error fetching user messages:', error);
    });
}
